import { useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useContextContrato } from "src/Contexts/Lancamentos/Contrato/ContratosContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { api } from "src/shared/setup/API/api";
import { handleFormatToNumeric } from "src/shared/Utils/FormatMoney";

interface IUseFormNovaParcela {
  cod_contrato: string;
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
  isIntern?: boolean;
}

export const UseFormNovaParcela = ({
  cod_contrato,
  setOpenModal,
  isIntern,
}: IUseFormNovaParcela) => {
  const { valuesInputNovaParcelaBordero } = useContextContrato();
  const { handleGetAlert } = useLayoutMainContext();
  const { setAttTable } = useConfigPageContext();

  const [loading, setLoading] = useState(false);

  const handleNovaParcela = async () => {
    setLoading(true);

    try {
      const cod_proposta = isIntern
        ? (
            await api.get(
              `/contratosByid/${encodeURIComponent(cod_contrato)}`
            )
          ).data.cod_proposta
        : valuesInputNovaParcelaBordero?.cod_proposta || cod_contrato.trim();

      const res = await api.post(`/bordero/create`, {
        cod_proposta,

        contratos_mensalidade: handleFormatToNumeric(
          valuesInputNovaParcelaBordero?.contratos_mensalidade
        ),

        data_vencimento_parcela:
          valuesInputNovaParcelaBordero?.data_vencimento_parcela,

        numero_parcela: valuesInputNovaParcelaBordero?.numero_parcela,
        contratos_vidas: valuesInputNovaParcelaBordero?.contratos_vidas,

        porcentagem_comissao_corretora:
          valuesInputNovaParcelaBordero?.porcentagem_comissao_corretora,
        porcentagem_comissao_corretor:
          valuesInputNovaParcelaBordero?.porcentagem_comissao_corretor,
        porcentagem_comissao_gerente:
          valuesInputNovaParcelaBordero?.porcentagem_comissao_gerente,
        porcentagem_comissao_supervisor:
          valuesInputNovaParcelaBordero?.porcentagem_comissao_supervisor,

        is_vitalicio_corretora: Boolean(
          valuesInputNovaParcelaBordero?.is_vitalicio_corretora
        ),
        is_vitalicio_corretor: Boolean(
          valuesInputNovaParcelaBordero?.is_vitalicio_corretor
        ),
        is_vitalicio_supervisor: Boolean(
          valuesInputNovaParcelaBordero?.is_vitalicio_supervisor
        ),
        is_vitalicio_gerente: Boolean(
          valuesInputNovaParcelaBordero?.is_vitalicio_gerente
        ),
      });

      setAttTable((item) => !item);
      handleGetAlert({ message: res.data.message });
      setOpenModal(false);
    } catch (error: any) {
      handleGetAlert({
        message:
          error?.response?.data?.message ||
          "Não foi possível criar a parcela. Verifique os dados e tente novamente.",
      });
    } finally {
      setLoading(false);
    }
  };

  return { handleNovaParcela, loading };
};
